import * as  types from './mutations-type'   //引入mutations-typs   ES6新的语法  这样就不用花括号引入
const mutations = {
     [types.ORIGINAL_INDEX](state,index){
         state.original_index = index
        //  console.log( state.original_index )
     },
     [types.CATE_LIST](state,list){
         state.cate_list=list
        //  console.log(state.cate_list)
     },
     [types.ACTIVITY_LIST](state,obj){
         state.activity_list = obj;
         console.log(state.activity_list)
     }
     
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js